import { get } from 'env-var';

export interface PublicRuntimeConfig {
	NEXT_PUBLIC_CONTENT_API_URL?: string;
	NEXT_PUBLIC_SEARCH_API_URL?: string;
}

export const PUBLIC_RUNTIME_CONFIG_ELEMENT_ID = '__PUBLIC_RUNTIME_CONFIG__';

let browserConfig: PublicRuntimeConfig | undefined;

/**
 * Replacement for publicRuntimeConfig, which was removed in Next.js 16.
 *
 * The same build is deployed to every environment, so these values must not be inlined at build time.
 * On the server they are read from the environment at request time, and _document passes them on to
 * the browser in a JSON script tag (see PublicRuntimeConfigScript).
 */
export const getPublicRuntimeConfig = (): PublicRuntimeConfig => {
	if (typeof window === 'undefined') {
		return {
			NEXT_PUBLIC_CONTENT_API_URL: get('NEXT_PUBLIC_CONTENT_API_URL').asString(),
			NEXT_PUBLIC_SEARCH_API_URL: get('NEXT_PUBLIC_SEARCH_API_URL').asString(),
		};
	}

	if (!browserConfig) {
		const element = document.getElementById(PUBLIC_RUNTIME_CONFIG_ELEMENT_ID);
		browserConfig = element?.textContent ? JSON.parse(element.textContent) : {};
	}

	return browserConfig;
};

export const PublicRuntimeConfigScript: React.FC = () => (
	<script
		id={PUBLIC_RUNTIME_CONFIG_ELEMENT_ID}
		type="application/json"
		dangerouslySetInnerHTML={{
			// Escape "<" so a value can never close the script tag
			__html: JSON.stringify(getPublicRuntimeConfig()).replace(/</g, '\\u003c'),
		}}
	/>
);
